
export const FETCH_CLIENTS_SUCCESS = 'FETCH_CLIENTS_SUCCESS';
export const DELETE_CLIENT_SUCCESS = 'DELETE_CLIENT_SUCCESS';
export const UPDATE_CLIENT_SUCCESS = 'UPDATE_CLIENT_SUCCESS';
export const CREATE_CLIENT_SUCCESS = "CREATE_CLIENT_SUCCESS";
export const GET_CLIENT_DATA_SUCCESS = "GET_CLIENT_DATA_SUCCESS";
export const FETCH_VIEW_CLIENTS_SUCCESS = 'FETCH_VIEW_CLIENTS_SUCCESS'